"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplatesForGroup = exports.getTemplateList = exports.getTemplate = void 0;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _defaultTemplate = _interopRequireDefault(require("./components/defaultTemplate"));
var _plugins = _interopRequireDefault(require("./plugins.js"));
var _flat = _interopRequireDefault(require("flat"));
var _checkDuplicateTemplateNames = _interopRequireDefault(require("./checkDuplicateTemplateNames.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function addTemplatesFromContext(context, templates) {
  if (!context) {
    return {};
  }
  (0, _forEach2["default"])(context.keys(), function (key) {
    var group = key.replace(/^.*\/([^/]+)\/[^/]+\/[^/]+\/index\.js$/, '$1');
    var type = key.replace(/^.*\/([^/]+)\/[^/]+\/index\.js$/, '$1');
    var template = context(key);
    templates[group] = templates[group] || {};
    templates[group][type] = templates[group][type] || [];
    templates[group][type].push(template["default"] ? template["default"] : template);
  });
}
function addTemplatesFromPlugins(templates) {
  if (!_plugins["default"].templates) {
    return;
  }
  var list = (0, _flat["default"])(_plugins["default"].templates, {
    maxDepth: 2
  });
  (0, _forEach2["default"])(list, function (value, key) {
    var _key$split = key.split('.'),
      _key$split2 = _slicedToArray(_key$split, 2),
      group = _key$split2[0],
      type = _key$split2[1];
    templates[group] = templates[group] || {};
    templates[group][type] = templates[group][type] || [];
    templates[group][type] = [].concat(_toConsumableArray(templates[group][type]), _toConsumableArray(value));
  });
}
var templatesContext = isTestEnv() ? null : require.context('./templates', true, /^\.\/([^/]+\/){2}index\.js$/);
var appTemplatesContext = isTestEnv() ? null : require.context('resources/assets/js', true, /^\.\/vendor\/flow\/templates\/(components|players)\/([^/]+\/){2}index\.js$/);
var templates = {
  players: {
    flow: [_defaultTemplate["default"]]
  }
};
addTemplatesFromContext(templatesContext, templates);
addTemplatesFromContext(appTemplatesContext, templates);
addTemplatesFromPlugins(templates);
(0, _checkDuplicateTemplateNames["default"])(templates);
var getTemplateList = exports.getTemplateList = function getTemplateList(group, type) {
  if (!templates[group] || !templates[group][type]) {
    return [];
  }
  return templates[group][type].map(function (template) {
    return _objectSpread({
      defaultSettings: {},
      settingsComponent: null
    }, template);
  });
};
var getTemplatesForGroup = exports.getTemplatesForGroup = function getTemplatesForGroup(group) {
  if (!templates[group]) {
    return {};
  }
  return (0, _mapValues2["default"])(templates[group], function (type) {
    return type.map(function (template) {
      return _objectSpread({
        defaultSettings: {},
        settingsComponent: null
      }, template);
    });
  });
};
var getTemplate = exports.getTemplate = function getTemplate(group, type, name) {
  if (!templates[group] || !templates[group][type]) {
    return null;
  }
  var template = (0, _find2["default"])(templates[group][type], {
    name: name
  });
  if (!template) {
    return null;
  }
  return template;
};
function isTestEnv() {
  return !!(process && process.env && process.env.NODE_ENV === 'test');
}